import Cookies from 'universal-cookie'

const cookies = new Cookies()

export const defaultOptions = {
    maxAge: 2147483647, // max value
    path: '/',
}

const cookiesWrapper = {
    set: (key, val, opts = {}) => {
        opts = { ...defaultOptions, ...opts }
        if (opts.expires) delete opts.maxAge
        return cookies.set(key, val, opts)
    },
    get: (key) => {
        return cookies.get(key)
    },
    remove: (key, options = { path: '/' }) => {
        return cookies.remove(key, options)
    }
}

window.__mv_cookies = cookiesWrapper

export default cookiesWrapper
